export function headerResetInitialStateRequest() {
  return {
    type: '@headers/RESET_INITIAL_STATE_REQUEST'
  }
}

export function headerResetInitialStateSuccess() {
  return {
    type: '@headers/RESET_INITIAL_STATE_SUCCESS'
  }
}

export function headerResetInitialStateFailure() {
  return {
    type: '@headers/RESET_INITIAL_STATE_FAILURE'
  }
}
